import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import onClickOutside from 'react-onclickoutside';
import s from './TooltipLayout.scss';
var TooltipLayout = /** @class */ (function (_super) {
    tslib_1.__extends(TooltipLayout, _super);
    function TooltipLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TooltipLayout.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        // schedule a re-calc if any of the non-popper props changed
        var nonPopperProps = [
            'showArrow',
            'height',
            'width',
            'className',
            'wrapperClassName',
            'contentClassName',
            'arrowClassName',
        ];
        var updateNeeded = nonPopperProps.reduce(function (prev, current) { return prev || _this.props[current] !== prevProps[current]; }, false);
        if (updateNeeded) {
            this.props.scheduleUpdate();
        }
    };
    TooltipLayout.prototype.render = function () {
        var _a = this.props, style = _a.style, placement = _a.placement, rootRef = _a.rootRef, outOfBoundaries = _a.outOfBoundaries, children = _a.children, className = _a.className, wrapperClassName = _a.wrapperClassName, arrowClassName = _a.arrowClassName, contentClassName = _a.contentClassName, width = _a.width, height = _a.height, showArrow = _a.showArrow, arrowProps = _a.arrowProps, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
        return (React.createElement("div", { ref: rootRef, style: style, className: classnames(s['root'], placement && s[placement], outOfBoundaries && s['out-of-bounds'], className), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
            React.createElement("div", { style: {
                    width: width,
                    height: height,
                }, className: classnames(s['tooltip-wrapper'], wrapperClassName) },
                React.createElement("div", { className: classnames(s['tooltip-content'], height && s['with-scroll'], contentClassName), style: { width: width, height: height } }, children),
                showArrow && (React.createElement("div", { ref: arrowProps && arrowProps.ref, className: classnames(s['arrow'], arrowClassName) })))));
    };
    TooltipLayout.prototype.handleClickOutside = function (evt) {
        this.props.onClickOutside && this.props.onClickOutside(evt);
    };
    return TooltipLayout;
}(React.Component));
export { TooltipLayout };
export default onClickOutside(TooltipLayout);
//# sourceMappingURL=TooltipLayout.js.map